import { Dialog, Stack, Grid, Button, Typography, Box } from '@mui/material';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';

import {
  useGetAuthenticationQuery,
  useDeleteDomainMutation,
} from '../../services/ADapi';

const RemoveDomain = ({ domainId, domainName, onClose }) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  // This left here for toast restoring
  // const notificationData = {
  //   isNotification: true,
  //   type: 'success',
  //   action: 'remove_domain',
  //   message: `${domainName} was successfully deleted`,
  // };

  const [deleteDomain] = useDeleteDomainMutation();

  const deleteDomainHandler = async () => {
    try {
      await deleteDomain({
        user_id,
        id: domainId,
      }).unwrap();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <Stack sx={{ gap: '12px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48px',
            height: '48px',
            margin: 'auto',
            borderRadius: '50%',
            backgroundColor: 'warning.main',
          }}
        >
          <GppBadOutlinedIcon
            fontSize="medium"
            sx={{ color: 'primary.contrastText' }}
          />
        </Box>
        <Typography variant="h6">
          Are you sure you want to delete <br /> the&nbsp;
          {domainName}?
        </Typography>
        <Typography component="p">
          Users and collections that are associated with this domain will also
          be deleted
        </Typography>
        <Grid container sx={{ pt: '12px', gap: 3 }}>
          <Button
            variant="error"
            size="small"
            onClick={deleteDomainHandler}
            sx={{
              flex: '1 0',
              backgroundColor: 'error.main',
              color: '#fff',
              '&:hover': { backgroundColor: 'error.main' },
            }}
          >
            Delete
          </Button>
          <Button variant="outlined" onClick={onClose} sx={{ flex: '1 0' }}>
            Cancel
          </Button>
        </Grid>
      </Stack>
    </Dialog>
  );
};

export default RemoveDomain;
